import { useCallback, useState } from 'react';

import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';

import { CustomEventNames, useMParticleContext } from 'state/mParticle';
import { routes } from 'utils/routing';

import { StoreLocatorViews } from '../types';

export const MPARTICLE_VIEW_EVENT_MAP = {
  [StoreLocatorViews.LIST_VIEW]: 'Selected list view',
  [StoreLocatorViews.MAP_VIEW]: 'Selected map view',
};

export default function useStoreLocatorView() {
  const { logNavigationClick } = useMParticleContext();
  const navigate = useNavigate();
  const location = useLocation();
  const { formatMessage } = useIntl();
  const [currentView, setCurrentView] = useState(StoreLocatorViews.LIST_VIEW);

  const updateCurrentView = useCallback(
    (newView: StoreLocatorViews) => {
      // log view switch event
      logNavigationClick(CustomEventNames.BUTTON_CLICK_STORE_LOCATOR_VIEW, {
        'Selected View': MPARTICLE_VIEW_EVENT_MAP[newView],
      });
      // switch view state
      setCurrentView(newView);

      // If we are on delivery route and select Map view go back to Pick Up
      if (newView === StoreLocatorViews.MAP_VIEW && location.pathname === routes.address) {
        navigate(formatMessage({ id: 'routes.storeLocator' }));
      }
    },
    [formatMessage, location.pathname, logNavigationClick, navigate]
  );

  return {
    currentView,
    currentViewIsList: currentView === StoreLocatorViews.LIST_VIEW,
    currentViewIsMap: currentView === StoreLocatorViews.MAP_VIEW,
    updateStoreLocatorView: updateCurrentView,
  };
}
